import { Component } from '@angular/core';
import { JsxgraphComponent, type JsxgraphBoard } from '@examdojo/core/jsxgraph';

@Component({
  selector: 'dojo-jsxgraph-example',
  standalone: true,
  imports: [JsxgraphComponent],
  template: `
    <div class="h-full w-full">
      <dojo-jsxgraph [boardId]="'example-board'" [options]="boardOptions" (boardReady)="onBoardReady($event)" />
    </div>
  `,
  styles: [
    `
      :host {
        @apply block h-full w-full;
      }
    `,
  ],
  host: { class: 'block h-full w-full' },
})
export class JsxgraphExampleComponent {
  readonly boardOptions = {
    boundingbox: [-5, 5, 5, -5] as [number, number, number, number],
    axis: true,
    showNavigation: true,
    showCopyright: false,
  };

  onBoardReady(board: JsxgraphBoard): void {
    board.create('functiongraph', [(x: number) => Math.sin(x), -Math.PI, Math.PI]);

    board.create('point', [2, 3], {
      name: 'A',
      size: 4,
      face: 'o',
    });

    board.create('circle', [
      [0, 0],
      [0, 2],
    ]);
  }
}
